import React from 'react';
import { motion, HTMLMotionProps } from 'framer-motion';
import { cn } from '../../lib/utils';
// Simple utility for class merging if not already present, otherwise I'll inline it or create it.
// Since I don't have a lib/utils yet, I'll create a simple one or just use template literals.
// I'll assume I need to create the utility first or just handle it here.
// To be safe and self-contained, I'll just use standard template literals in this file or a small helper.
interface ButtonProps extends HTMLMotionProps<'button'> {
  variant?: 'primary' | 'secondary' | 'outline';
  size?: 'sm' | 'md' | 'lg' | 'xl';
  fullWidth?: boolean;
}
export function Button({
  className,
  variant = 'primary',
  size = 'md',
  fullWidth = false,
  children,
  ...props
}: ButtonProps) {
  const baseStyles = 'inline-flex items-center justify-center rounded-full font-bold transition-colors focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-[#E8652D] disabled:opacity-50 disabled:pointer-events-none';
  const variants = {
    primary: 'bg-[#E8652D] text-white hover:bg-[#d55620] shadow-lg shadow-orange-900/20',
    secondary: 'bg-white text-[#111111] hover:bg-gray-100 border border-gray-200',
    outline: 'border-2 border-[#E8652D] text-[#E8652D] hover:bg-[#E8652D]/10'
  };
  const sizes = {
    sm: 'h-9 px-4 text-sm',
    md: 'h-11 px-6 text-base',
    lg: 'h-14 px-8 text-lg',
    xl: 'h-16 px-10 text-xl'
  };
  const widthClass = fullWidth ? 'w-full' : '';
  return <motion.button whileHover={{
    scale: 1.02
  }} whileTap={{
    scale: 0.98
  }} className={`${baseStyles} ${variants[variant]} ${sizes[size]} ${widthClass} ${className || ''}`} {...props} data-id="element-242">
      {children}
    </motion.button>;
}